// clamp.js
'use strict';

/**
 * Clamps a value between a minimum and maximum bound
 * @param {Object} params - The parameters object
 * @param {number} params.value - The value to clamp
 * @param {number} params.min - The minimum bound
 * @param {number} params.max - The maximum bound
 * @returns {number} The clamped value between min and max
 */
const clamp = ({ value, min, max } = {}) => {
  if (min == null && max == null) {
    return value;
  }
  if (min == null) {
    return Math.min(value, max);
  }
  if (max == null) {
    return Math.max(value, min);
  }
  return Math.min(Math.max(value, min), max);
};

export default clamp;
